/**
 * @Author：zsj
 * @Date：2022/08/11
 */


import React, { useContext } from 'react'
import routes from '@/routes';
import renderRoutes from '@/routes/react-router-config';
import { PermissionCtx } from '@/store/context'

export default () => {
    const { routerArr } = useContext(PermissionCtx);
    return renderRoutes(routes, routerArr)
}
